var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sy-btn-ellipsis"},[_vm._t("default"),_c('button-container',{attrs:{"buttons":_vm.buttons}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }